/* global jQuery */

/**
 * This file contains a collection of utility methods intended to be usable across the GF PayPal Checkout JS add-on.
 */
( function( $ ) {
	const GFPayPalCheckoutUtils = {
		subscriptions: {
			getNoticeContainer: () => {
				return $( '#gf-paypal-checkout-unsupported-payment-warning' );
			},
			getUnsupportedPaymentOptionMessage: () => {
				return `Credit card fields are not currently supported for subscriptions and will not display on your form.`;
			},

			getUnsupportedPaymentMethodMarkup: ( legacy = false ) => {
				let containerClasses = 'gform-settings__wrapper';
				let alertClasses = 'alert gforms_note_warning';

				if ( legacy ) {
					alertClasses += ' alert_yellow';
					containerClasses += ' gform-alert__legacy';
				}

				return `<div id="gf-paypal-checkout-unsupported-payment-warning" class="${ containerClasses }">
							<div class="${ alertClasses }">
								<p>${ GFPayPalCheckoutUtils.subscriptions.getUnsupportedPaymentOptionMessage() }</p>
							</div>
						</div>`;
			},
		},
	};

	window.GFPayPalCheckoutUtils = GFPayPalCheckoutUtils;
}( jQuery ) );
